export default "__VITE_ASSET__CuoiEzBq__"